var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.4 64C21 64 16 69.4 16 76v12l240 168L496 88V76c0-6.6-5-12-11.4-12H27.4zM496 132L256 300 16 134v302c0 6.6 5 12 11.4 12h457.2c6.3 0 11.4-5.4 11.4-12V132z","fill":"#f5f5f5"}));
}

Mail.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = Mail;

Mail.default = Mail;
